import React, { useCallback, useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { Autocomplete, Box, Button, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import GlobalDatagrid from '../../../components/mui/DataGrid/GlobalDatagrid';
import { getCROLists } from '../../../redux/features/CRDslice';
import AssignCroModal from './AssignCroModal';
import AssignBatchModal from './AssignBatchModal';
import { getAllNonAssignedLeads } from '../../../redux/features/batchSlice';
import UnAssignedBatchLeadsTableHeader from './UnAssignedBatchLeadsTableHeader';
import { getProjects } from '../../../redux/features/generalSlice';

const croAssignOptions = [
  { label: 'All', value: '' },
  { label: 'Assigned', value: 'assigned' },
  { label: 'Un-Assigned', value: 'unassigned' },
];

const UnAssignedBatchLeadsLanding = ({ cro, crm }) => {
  const dispatch = useDispatch();

  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { search, checkedRowsIds } = paginationData;

  const { loading, unAssignedLeads } = useSelector((state) => state.batch);
  const { croList } = useSelector((state) => state.crd);
  const { allprojects } = useSelector((state) => state.general);

  const [assignModal, setAssignModal] = useState(false);
  const [gridKey, setGridKey] = useState(0);
  const [selectedProject, setSelectedProject] = useState(null);
  const [croAssignStatus, setCroAssignStatus] = useState(croAssignOptions[0]);

  const projectOptions = Array.isArray(allprojects) ? allprojects : allprojects?.projects || [];
  // Load projects and CRO list once
  useEffect(() => {
    dispatch(getProjects());

    if (crm) {
      dispatch(getCROLists());
    }
  }, [dispatch, crm]);

  const fetchLeads = useCallback(() => {
    dispatch(
      getAllNonAssignedLeads({
        search,
        project_id: selectedProject?.id || '',
        cro_assign_status: crm ? croAssignStatus?.value || '' : '',
      }),
    );
  }, [dispatch, search, selectedProject, croAssignStatus, crm]);

  // Load leads whenever search/project/cro assign status changes
  useEffect(() => {
    fetchLeads();
  }, [fetchLeads]);

  const columns = useMemo(() => {
    const baseColumns = [...UnAssignedBatchLeadsTableHeader];

    if (crm) {
      baseColumns.push({
        field: 'assigned_cro_name',
        headerName: 'Assigned CRO',
        flex: 1,
        minWidth: 200,
        renderCell: (params) => params.row?.assigned_cro_name || '-',
      });
    }

    return baseColumns;
  }, [crm]);

  return (
    <GlobalWrapper title="Un Assigned Batch Leads">
      <Box
        mb={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        // flexDirection={{ xs: 'column', sm: 'row' }}
        gap={2}
      >
        <Box display="flex" alignItems="center" gap={2} flexDirection={{ xs: 'column', sm: 'row' }}>
          <Autocomplete
            fullwidth
            sx={{ width: 200 }}
            options={projectOptions}
            value={selectedProject}
            onChange={(event, value) => setSelectedProject(value)}
            getOptionLabel={(option) => option.name || ''}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => <TextField {...params} label="Project" size="small" />}
          />

          {crm && (
            <Autocomplete
              sx={{ width: 200 }}
              options={croAssignOptions}
              value={croAssignStatus}
              onChange={(event, value) => setCroAssignStatus(value || croAssignOptions[0])}
              getOptionLabel={(option) => option.label || ''}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              renderInput={(params) => <TextField {...params} label="Assigned CRO" size="small" />}
            />
          )}
        </Box>

        <Button variant="contained" onClick={() => setAssignModal(true)} disabled={!checkedRowsIds?.length}>
          {crm ? 'Assign CRO' : 'Assign Batch'}
        </Button>
      </Box>

      <GlobalDatagrid
        key={gridKey}
        tableHead={columns}
        rows={unAssignedLeads || []}
        meta={unAssignedLeads?.length || 0}
        loading={loading}
        rowUniqueId="course_enrollment_id"
        checkboxSelection
        rowClick={false}
      />

      {crm ? (
        <AssignCroModal
          open={assignModal}
          setOpen={setAssignModal}
          croList={croList}
          selectedLeads={checkedRowsIds}
          onSuccess={() => {
            fetchLeads();
            setGridKey((prev) => prev + 1);
          }}
        />
      ) : (
        <AssignBatchModal
          open={assignModal}
          setOpen={setAssignModal}
          selectedLeads={checkedRowsIds}
          onSuccess={() => {
            fetchLeads();
            setGridKey((prev) => prev + 1);
          }}
        />
      )}
    </GlobalWrapper>
  );
};

export default UnAssignedBatchLeadsLanding;
